export enum ViewContext {
  DEFAULT = 'module',
  SEARCH = 'search',
  FAVOURITE = 'favourite',
}
